import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionTitle = ({ eyebrow, title, children, testid }) => (
  <div className="mb-10 sm:mb-14 max-w-2xl" data-testid={testid}>
    {eyebrow && <p className="eyebrow mb-4">{eyebrow}</p>}
    <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl leading-tight text-[#F8F6F1]">{title}</h2>
    {children && <p className="mt-4 text-sm sm:text-base text-[#F8F6F1]/65 leading-relaxed">{children}</p>}
  </div>
);
